import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Rate } from "./rate";

export class RateTemplate extends Resource {
    public override type = 'rateTemplates';

    @prop()
    @required()
    public rateId!: string;
    @prop()
    public rate!: Rate;

    @prop()
    @required()
    public name!: string;

}